"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseLink = void 0;
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var CollapseLink = function (_a) {
    var renderLink = _a.renderLink, children = _a.children, activeCollapse = _a.activeCollapse;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.collapseLink, " ").concat(activeCollapse && styles_module_scss_1.default.activeCollapseLink) },
        renderLink(),
        react_1.default.createElement("section", { className: styles_module_scss_1.default.collapseLinkLinks }, children)));
};
exports.CollapseLink = CollapseLink;
